<template>
  <div class="edit-base-shelf-item thumbnailShelf">
    <div class="edit-shelfname-label">微信链接封面</div>
    <input type="file" id="uploads" ref="uploadThum" value="imgFile" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event)" style="display:none" />
    <label for="uploads" class="base_content">
      <template v-if="thumbnail">
        <img :src="thumbnail" alt="图片不在" class="imgSize" />
      </template>
      <template v-if="!thumbnail">
        <img src="@imgs/share.png" alt="" class="imgSize" />
      </template>
      <div>上传链接封面</div>
    </label>
    <CropDialog ref="crop" :cropImgUrl="cropImgUrl" @cropConfirm="cropConfirm"></CropDialog>
  </div>
</template>

<script>
import CropDialog from '@components/editDrawer/edit/CropDialog.vue'
export default {
  name: 'shelfLibThum',
  props: {
    type: Object
  },
  data() {
    return {
      cropImgUrl: '',
      myType: this.type
    }
  },
  computed: {
    thumbnail: {
      get() {
        let data1 = this.$store.state.config.bookLibObj.thumbnail
        let data2 = this.$store.state.config.bookShelfObj.thumbnail
        if (this.myType.getType == 'Lib') {
          return data1 === 'default' ? false : data1
        } else {
          return data2 === 'default' ? false : data2
        }
      },
      set(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.myType.setType + 'THUMBNAIL', newValue)
      }
    }
  },
  components: {
    CropDialog
  },
  methods: {
    uploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.cropImgUrl = res.target.result
        _this.$refs.uploadThum.value = ''
        _this.$refs.crop.dialogVisible = true
        _this.$nextTick(() => {
          _this.$refs.crop.init()
        })
      }
    },
    cropConfirm(file) {
      this.$store.commit(`config/UPDATE_BOOK${this.myType.setType}THUMBNAIL`, file)
      document.querySelector('#uploads').value = ''
    }
  }
}
</script>

<style></style>
